module.exports = __webpack_public_path__ + "img/pr-1.ef6336c5.png";